import {
  analyticsTransformer,
  callsMeetingsTransformer,
  clientsAndPipelineTransformer,
  userKpiTransformer,
} from "./transformResponse/salesKpiTransformer"

import staffListTransformer from "features/shared/api/transformResponse/staffListTransformer"
import parentApi from "store/parentApi"
import { convertQueryObjToString, filterParamsObject } from "utils"
import userKpiTargetAchievedTransformer from "./transformResponse/targetAchievedTransformer"

const salesKpiApi = parentApi.injectEndpoints({
  endpoints: build => ({
    getStaff: build.query({
      query: ({ userId, ...restParams }) =>
        `/users/reportees/${userId}?teamTypeKeys=sales,secondarySales,acquisition&hierarchy=true&module=reports&subModule=kpiSalesReport&${convertQueryObjToString(
          restParams
        )}`,
      transformResponse: response => staffListTransformer(response),
    }),
    getKPIReportAnalytics: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_sales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: response => analyticsTransformer(response),
      providesTags: ["kpi-reports"],
    }),
    getSalesUserKPI: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_sales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: (response, req, params) => userKpiTransformer(response, req, params),
      providesTags: ["kpi-reports-user-kpi"],
    }),

    getSalesComparison: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_sales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: (response, req, params) => analyticsTransformer(response, req, params),
      providesTags: ["kpi-reports-user-kpi"],
    }),
    getKPIClients: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_sales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: (response, _meta, args) => {
        return args?.load === "target_vs_achieved"
          ? userKpiTargetAchievedTransformer(response, _meta, args)
          : clientsAndPipelineTransformer(response, _meta, args)
      },
      providesTags: ["kpi-reports-clients"],
    }),
    getKPICallsOrMeetings: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_sales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: (response, req, params) => callsMeetingsTransformer(response, req, params),
      providesTags: ["kpi-reports-calls-or-meetings"],
    }),
  }),
  overrideExisting: false,
})

export const {
  useLazyGetStaffQuery,
  useGetKPIReportAnalyticsQuery,
  useGetSalesUserKPIQuery,
  useLazyGetSalesComparisonQuery,
  useGetSalesComparisonQuery,
  useGetKPIClientsQuery,
  useGetKPICallsOrMeetingsQuery,
} = salesKpiApi
